import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=42af0c0b"
import script from "./Changes.vue?vue&type=script&lang=js"
export * from "./Changes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports